import { render, staticRenderFns } from "./recommendedManage.vue?vue&type=template&id=382e57d0&scoped=true"
import script from "./recommendedManage.vue?vue&type=script&lang=js"
export * from "./recommendedManage.vue?vue&type=script&lang=js"
import style0 from "./recommendedManage.vue?vue&type=style&index=0&id=382e57d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e57d0",
  null
  
)

export default component.exports